import React from "react"
import { Dayjs } from "dayjs"
import { ICustomFieldTemplate } from "../entities/job/interface"
import TextComponent from "./Common/TextField"
import DateTimeComponent from "./Common/DateTime"
import DateComponent from "./Common/Date"
import TimeComponent from "./Common/Time"
import SelectComponent from "./Common/Switch"
import { Box, FormControl, MenuItem, Select, Typography } from "@mui/material"

interface Props {
    field: ICustomFieldTemplate
    value: string | Dayjs | null | boolean
    error?: string
    onChange: (id: string, value: string | Dayjs | null | boolean) => void
    isEditable: boolean
    type: string
}

const CustomField: React.FC<Props> = ({ field, value, error, onChange, isEditable, type }) => {
    if (field.enumeratedValues && field.enumeratedValues.length > 0) {
        return (
            <Box width={"100%"} display={"flex"} flexDirection={"column"}>
                <Box
                    width={"100%"}
                    display={"flex"}
                    borderRadius={"10px"}
                    bgcolor={"#027BBA"}
                    justifyContent={"space-between"}
                >
                    <FormControl fullWidth>
                        <Select
                            onChange={(event) => onChange(field.customFieldTemplateId, event.target.value)}
                            disabled={!isEditable}
                            value={value}
                            displayEmpty
                            renderValue={(selected) => (selected === "" ? "Select" : String(selected))}
                            error={error ? true : false}
                            sx={{
                                paddingX: 1,
                                borderRadius: 0.2,
                                border: "none", // Removing border
                                color: "white",
                                "& .MuiOutlinedInput-notchedOutline": {
                                    border: "none", // Removes the border around the input
                                },
                                "& .MuiSelect-icon": {
                                    color: "white", // Optional: changes the icon color
                                },
                            }}
                        >
                            {/* Default "Select" MenuItem */}
                            <MenuItem value="">{"Select"}</MenuItem>

                            {/* Enumerated values */}
                            {field.enumeratedValues.map((enumeratedValue: any, index: number) => (
                                <MenuItem key={index} value={enumeratedValue?.dropdownValues}>
                                    {enumeratedValue?.dropdownValues}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Box>
                {error && error?.length > 0 && (
                    <Typography variant="caption" color="error" fontSize={"15px"}>
                        {error}
                    </Typography>
                )}
            </Box>
        )
    }
    switch (field.type) {
        case "STRING":
            return (
                <TextComponent
                    field={field}
                    value={value as string}
                    error={error}
                    onChange={onChange}
                    isEditable={isEditable}
                    type={type}
                />
            )
        case "NUMBER":
            return (
                <TextComponent
                    field={field}
                    value={value as string}
                    error={error}
                    onChange={onChange}
                    isEditable={isEditable}
                    type={type}
                />
            )
        case "DATE_TIME":
            return (
                <DateTimeComponent
                    field={field}
                    value={value as Dayjs | null}
                    error={error}
                    onChange={onChange}
                    isEditable={isEditable}
                />
            )
        case "DATE_ONLY":
            return (
                <DateComponent
                    field={field}
                    value={value as Dayjs | null}
                    error={error}
                    onChange={onChange}
                    isEditable={isEditable}
                />
            )
        case "TIME_ONLY":
            return (
                <TimeComponent
                    field={field}
                    value={value as Dayjs | null}
                    error={error}
                    onChange={onChange}
                    isEditable={isEditable}
                />
            )
        case "BOOLEAN":
            return (
                <SelectComponent field={field} value={value as boolean} onChange={onChange} isEditable={isEditable} />
            )
        default:
            return null
    }
}

export default CustomField
